import React, { useState } from 'react';
import './Tabs.css';
import CategoricalStatsTable from './CategoricalStatsTable';
import CustomPieCharts from './CustomPieCharts';
import StatsTable from './StatsTable';
// import VirtualTable from "./VirtualTable";
// import "antd/dist/antd.css";



const SummaryDataTables = ({ numericData, numericColumns, categoricalData, categoricalColumns, missingGraphsdata }) => {
    const [activeTab, setActiveTab] = useState(1);

    const switchTab = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    return (
        <div className="container">
            {/* Tabs */}
            <div className="bloc-tabs">
                <div
                    className={activeTab === 1 ? "tabs active-tabs" : "tabs"}
                    onClick={() => switchTab(1)}
                >
                    Data Statistics
                </div>
                <div
                    className={activeTab === 2 ? "tabs active-tabs" : "tabs"}
                    onClick={() => switchTab(2)}
                >
                    Numerical Stats
                </div>
                <div
                    className={activeTab === 3 ? "tabs active-tabs" : "tabs"}
                    onClick={() => switchTab(3)}
                >
                    Categorical Stats
                </div>
            </div>

            {/* Content */}
            <div className="content-tabs">
                <div className={activeTab === 1 ? "content active-content" : "content"}>
                    <div style={{ display: 'flex', height: '28rem', width: '100%', flexDirection: 'column', overflow: 'auto' }}>
                        <CustomPieCharts data={missingGraphsdata} />
                    </div>

                </div>
                <div className={activeTab === 2 ? "content active-content" : "content"}>
                    <div style={{ display: 'flex', height: '28rem', width: '100%', flexDirection: 'column', overflowY: 'auto' }}>
                       
                        <StatsTable data={numericData} allColumns={numericColumns} />
                    </div>
                </div>
                <div className={activeTab === 3 ? "content active-content" : "content"}>
                    <div style={{ display: 'flex', height: '28rem', width: '100%', flexDirection: 'column', overflowY: 'auto' }}>
                        {categoricalColumns.length > 0 ? <CategoricalStatsTable data={categoricalData} allColumns={categoricalColumns} /> : ""}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SummaryDataTables;
